import { useState, useEffect } from 'react';

import { useRouter } from 'next/router';

import ActionButton from '@core/components/actionbutton/ActionButton';

import classes from './SearchBar.module.scss';

const SearchBar = () => {
	const router = useRouter();
	// const [searchParams, setSearchParams] = useSearchParams({});
	const [searchParams, setSearchParams] = useState({});
	const [keyword, setKeyword] = useState();

	useEffect(() => {
		if (router.isReady) {
			if (router.query.keyword && router.query.keyword !== keyword) {
				setKeyword(router.query.keyword);
			}
			const { id, ...searchparams } = router.query;
			setSearchParams(searchparams);
		}
	}, []);

	const searchParamSetter = (value, replace = true) => {
		setSearchParams((prevState) => ({ ...prevState, keyword: value }));
		const newKeyword = Boolean(value) ? { keyword: value } : {};
		router.replace({
			pathname: router.pathname,
			query: {
				...router.query,
				...newKeyword
			}
		});
		// setSearchParams({ ...Object.fromEntries(searchParams), keyword: value }, { replace: replace });
	};

	const searchSubmitHandler = (e) => {
		e.preventDefault();
		if (e.target.value && searchParams.keyword !== e.target.value) {
			searchParamSetter(e.target.value);
		}
	};

	useEffect(() => {
		const keywordDebounce = setTimeout(() => {
			if (keyword && searchParams.keyword !== keyword) {
				searchParamSetter(keyword);
			}
		}, 1000);
		return () => {
			clearTimeout(keywordDebounce);
		};
	}, [keyword]);

	return (
		<>
			<form onSubmit={searchSubmitHandler} className={`${classes['form']} col-12`}>
				<h2>Search Courses</h2>
				<input
					name="searchKeyword"
					type="search"
					role="searchbox"
					placeholder="Search courses"
					value={keyword}
					onChange={(e) => setKeyword(e.target.value)}
				/>
				<ActionButton kind="blank" onClick={() => router.push('/')}>
					Cancel
				</ActionButton>
			</form>
		</>
	);
};

export default SearchBar;
